import { useEffect, type RefObject } from 'react';
import { useRecoilValue, waitForAll } from 'recoil';
import {
  blockFonts as blockFontsState,
  blockSubHeader as blockSubHeaderState,
  reportZoom as reportZoomState,
} from 'venn-state';
import type HighchartsReact from 'highcharts-react-official';
import type { Rect } from 'react-measure';

export const useChartReflow = (
  blockId: string,
  bounds: Rect | undefined,
  chartRef: RefObject<HighchartsReact.RefObject>,
) => {
  const blockFonts = useRecoilValue(waitForAll(Object.values(blockFontsState).map((state) => state(blockId))));
  const blockSubHeader = useRecoilValue(blockSubHeaderState(blockId));
  const reportZoom = useRecoilValue(reportZoomState);
  useEffect(() => {
    chartRef.current?.chart?.reflow?.();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [chartRef, bounds?.width, bounds?.height, blockSubHeader, reportZoom, ...blockFonts]);
};
